module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.stage === 'action') ? _c('Action', {
    attrs: {
      "inputReadOnly": true,
      "defaultNum": _vm.amountPayload.emptyCount,
      "deviceId": _vm.currentEvent.device.id,
      "onlyPc": true
    },
    on: {
      "setActionData": _vm.getThisAmount
    }
  }, [_c('h5', [_vm._v("此藥盒取出空瓶數量")])]) : _vm._e(), (_vm.stage === 'finish') ? _c('Loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e1adb82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReturnEmptyFlow/ActionWrap.vue
// module id = 1410
// module chunks = 1